import axios from 'axios';
import {useQuery} from 'react-query';
import {environment} from '../config/environment';

export const useAddress = (address: string, options?: any) => {
    return useQuery(
        ['address', address],
        () => axios.get(`${environment.apiBase}/address/detail?address=${address}`).then((res) => res.data),
        {
            staleTime: 1000 * 60 * 5,
            cacheTime: 1000 * 60 * 5,
            ...options,
        }
    );
};

export default useAddress;
